import React, { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { integer } from "aws-sdk/clients/storagegateway";


const UsersList = (props: any) => {
    const [users, setUsers] = useState<any>([]);

    useEffect(() => {
        setUsers(props.users);
    }, [props.users]);

    const editUser = (user:any) => {
        if(props.onSelectedUserId) {
            props.onSelectedUserId(user.id);
        }
    }

    return (
        <>
        <Table striped bordered hover variant="dark">
            <thead>
                <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Role</th>
                </tr>
            </thead>
            <tbody>
                {
                    users.map((user:any, index:integer) => (
                        <tr key={index}>
                            <td>
                                <Button 
                                    variant="primary"
                                    size="sm"
                                    onClick={() => editUser(user)}>
                                        Edit
                                </Button>
                            </td>
                            <td>{user.name}</td>
                            <td>{user.email}</td>
                            <td>{user.roles}</td>
                        </tr>
                    ))
                }
            </tbody>
            </Table>
        </>
    );
}

export default UsersList;